/**
 * Filename: 公共方法
 * Created Date:2021/9/6
 * Author: pyh
 *
 * Copyright (c) 2021 Your Company
 */
export default {
    /**
     * @author pyh
     * @description 本地路径转base64
     * @param {file}} file - 文件
     * @returns 无
     */
    path2base64(file) {
        return new Promise((resolve, reject) => {
            let a = new FileReader();
            a.readAsDataURL(file);
            a.onload = e => {
                resolve(e.target.result);
            }
            a.onerror = e => reject(e);
        })
    },
    /**
     * @author sxx
     * @description 将图片转成base64，防止截图时，无法找到图片
     * @param {url} url - 图片引入路径名称
     * @returns 无
     */
    getBase64Image(url) {
        var img = new Image();
        img.src = url;
        return new Promise((resolve, reject) => {
            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);
                var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                var dataURL = canvas.toDataURL("image/" + ext);
                resolve(dataURL)
            };
            img.onerror = () => {
                console.log('error')
            }
        })
    },
    /**
     * @author sxx
     * @description    查看是 windows || mac
     * @param { }
     * @returns mac||win
     */
    winOrMac() {
        var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        return isMac ? 'mac' : 'win'
    },
    /**
     * @author sxx
     * @description    dom转string，去掉image的href=base64
     * @param {item}  item - 转换图片
     * @returns  outerHTML
     */
    handleHTML(item) {
        if (item.type === 'image') { // 如果是图片，去掉base64
            const clone = item.node.cloneNode(true)
            clone.setAttribute("href", '');
            return clone.outerHTML
        } else {
            return item.node.outerHTML
        }
    },
    /* 根据传入的format，返回对应格式时间 */
    formatTime(result) {
        let h = Math.floor(result / 3600) <
            10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
        let m = Math.floor((result / 60 % 60)) <
            10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
        let s = Math.floor((result % 60)) <
            10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
        return Math.floor(result / 3600) == 0 ? m + ':' + s : h + ':' + m + ':' + s
    },
    // val:秒数
    showTime(val){
        if(val<60){
            return val;
        }else{
            var min_total = Math.floor(val / 60); // 分钟
            return min_total
        }
    },
    //获取日期
    // formatDate(time, type, format) {
    //     /**
    //      * time 时间
    //      * type 类型（默认'yyyy-MM-dd HH:mm'）
    //      */
    //     if (!time) return time;
    //     var date = '';
    //     if (format) {
    //         date = time;
    //     } else {
    //         if (typeof time !== 'number') {
    //             time = time.replace(/-/g, '/');
    //         }
    //         date = new Date(time);
    //     }
    //     type = type ? type : 'yyyy-MM-dd HH:mm';
    //     var seperator1 = '-';
    //     var seperator2 = ':';
    //     var seperator3 = '/';
    //     var month = (date.getMonth() + 1).toString();
    //     var day = date.getDate().toString();
    //     var hours = date.getHours().toString();
    //     var minutes = date.getMinutes().toString();
    //     var seconds = date.getSeconds().toString();
    //     month = month.length === 1 ? '0' + month : month;
    //     day = day.length === 1 ? '0' + day : day;
    //     hours = hours.length === 1 ? '0' + hours : hours;
    //     minutes = minutes.length === 1 ? '0' + minutes : minutes;
    //     seconds = seconds.length === 1 ? '0' + seconds : seconds;
    //     if (type === 'yyyyMMddHHmmss') {
    //         return (
    //             date.getFullYear() +
    //             month +
    //             day +
    //             hours +
    //             minutes +
    //             seconds
    //         );
    //     } else if (type === 'yyyy-MM-dd HH:mm:ss') {
    //         return (
    //             date.getFullYear() +
    //             seperator1 +
    //             month +
    //             seperator1 +
    //             day +
    //             ' ' +
    //             hours +
    //             seperator2 +
    //             minutes +
    //             seperator2 +
    //             seconds
    //         );
    //     } else if (type === 'yyyy-MM-dd HH:mm') {
    //         return (
    //             date.getFullYear() +
    //             seperator1 +
    //             month +
    //             seperator1 +
    //             day +
    //             ' ' +
    //             hours +
    //             seperator2 +
    //             minutes
    //         );
    //     } else if (type === 'yyyy-MM-dd') {
    //         return date.getFullYear() + seperator1 + month + seperator1 + day;
    //     } else if (type === 'yyyy-MM') {
    //         return date.getFullYear() + seperator1 + month;
    //     } else if (type === 'yyyy/MM') {
    //         return date.getFullYear() + seperator3 + month;
    //     } else if (type === 'yyyy') {
    //         return date.getFullYear();
    //     } else if (type === 'HH:mm') {
    //         return hours + seperator2 + minutes;
    //     } else if (type === 'MM-dd') {
    //         return month + seperator1 + day;
    //     }
    // },
    /* 根据传入的format，返回对应格式时间 */
    formatDate(fmt, date) {
        let ret;
        date = new Date(date);
        const opt = {
            'y+': date.getFullYear().toString(), // 年
            'm+': (date.getMonth() + 1).toString(), // 月
            'd+': date.getDate().toString(), // 日
            'H+': date.getHours().toString(), // 时
            'M+': date.getMinutes().toString(), // 分
            'S+': date.getSeconds().toString(), // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt);
            if (ret) {
                fmt = fmt.replace(
                    ret[1],
                    ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                );
            }
        }
        return fmt.includes('NaN') ? '' : fmt
    },
    // 秒转换成时间
    secondToTime(time) {
        let totalSecond = time;
        let hour = parseInt(totalSecond / 3600);
        hour = hour < 10 ? '0' + hour : hour;
        let minute = parseInt((totalSecond - (hour * 3600)) / 60);
        minute = minute < 10 ? '0' + minute : minute;
        let second = parseInt(totalSecond - (hour * 3600) - (minute * 60));
        second = second < 10 ? '0' + second : second;
        return hour + ':' + minute + ':' + second;
    },
    // 获取当前直播时间 00:00:02 转成 2s
    getLiveTime(time) {
        let timeArr = time.split(":");
        let timeSecond = 0;
        if (timeArr.length == 2) {
            timeSecond = parseInt(timeArr[0] * 60) + parseInt(timeArr[1]);
        } else if (timeArr.length == 3) {
            timeSecond =
                parseInt(timeArr[0] * 60 * 60) +
                parseInt(timeArr[1] * 60) +
                parseInt(timeArr[2]);
        }
        return timeSecond;
    },
    //获取文件大小转换
    unitTran(size) {
        // size 是 Byte
        let hasUpload = 0 + 'M';
        if (parseInt(size / 1024) < 1024) { // KB
            hasUpload = (size / 1024).toFixed(2) + 'KB'
        } else if (parseInt(size / 1024 / 1024) < 1024) { // M
            hasUpload = (size / 1024 / 1024).toFixed(2) + 'M'
        } else if (parseInt(size / 1024 / 1024 / 1024) < 1024) { // GB
            hasUpload = (size / 1024 / 1024 / 1024).toFixed(2) + 'GB'
        }
        return size < 0 ? 0 + 'M' : hasUpload;
    },
    // 拷贝
    deepCopy(obj) {
        var result = Array.isArray(obj) ? [] : {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    result[key] = this.deepCopy(obj[key]); //递归复制
                } else {
                    result[key] = obj[key];
                }
            }
        }
        return result;
    },

    // 判断数组返回翻译 list 数组 key后台数据 label需要值字段 value对比字段
    // 例：list = [{name: '中文', nameEn: 'English', key: 'key1'}], 取'key1'的中英文
    //    $utils.getValueByKey(list, 'key1', 'name', 'key');
    getValueByKey(list, key, label, value) {
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (item[value] == key) {
                if (item[label]) {
                    return item[label];
                } else {
                    return item[label];
                }
            }
        }
    },

    /**
     * @description 根据标签获取对应的片段数组
     * @param {String | Array} labelParam
     * 	当type传入为字符串时，找到列表中标签相等的并返回。
     * 	当type传入为数组时，格式需为['Shot', 'FkShot/goal', 'FkShot/OnTarget' 'Penalty/goal' ]
     * 	如果该标签含二级标签，用"/"拼接。
     * @returns {Array | Object}
     * 传入为字符串时，返回片段数组。
     * 传入为数组时，返回片段对象，格式如下：
     * 	{
     * 		Shot: {
     * 			clips: [],
     * 		},
     * 		FkShot: {
     * 			clips: [],
     * 			goal: [],
     * 			OnTarget: [],
     * 		},
     * 		Penalty: {
     * 			clips: [],
     * 			goal: []
     * 		}
     * 	}
     */
    getClips(clipsData, labelParam) {
        if (!labelParam) {
            throw Error('请传入labelParam')
        }
        if (typeof labelParam=== 'string') {
            return clipsData.filter(item => {
                return item.label === labelParam
            })
        } else if (Array.isArray(labelParam)) {
            const obj = {}
            labelParam = labelParam.map(item => {
                if (item.includes('/')) {
                    const arr = item.split('/')
                    let level1Label = arr[0]

                    obj[level1Label] = obj[level1Label] || { clips: [] }
                    obj[level1Label][arr[1]] = [] // 二级标签clip数组
                    obj[level1Label]['level2Label'] = arr[1]
                    return level1Label
                } else {
                    obj[item] = {
                        clips: [],
                    }
                    return item
                }
            })

            clipsData.forEach(item => {
                labelParam.forEach(label => {
                    if (label === item.label) {
                        const currentLabelObj = obj[label]
                        const level2Label = currentLabelObj.level2Label

                        currentLabelObj.clips.push(item)
                        if (level2Label) {
                            const level2Item = (item.secondary || []).find(level2 => level2Label === level2)
                            if (level2Item) {
                                currentLabelObj[level2Label].push(item)
                            }
                        }
                    }
                })
            })

            return obj
        }
    },

    /**
     * @description 根据视频的时间节点返回对应的分钟数
     * @param {second， decimal} second - 视频秒数   decimal - 保留几位小数
     * @returns min - 分钟数
     *
     **/
    videoSecondToMin(second, decimal){
        // 不传值，只保留整数
        let num = parseInt(decimal)?parseInt(decimal):0;

        let min = parseInt(second/60*(num==0?1:10**num))/(num==0?1:10**num)

        return min
    }

}